import ipad from '../img/ipad.png';
import masthead from '../img/bg-masthead.jpg';
import signup from '../img/bg-signup.jpg';
import demo1 from '../img/demo-image-01.jpg';
import demo2 from '../img/demo-image-02.jpg';
import Satzung from '../files/satzung.pdf';
import Beitritt from '../files/sepa_beitritt.pdf';
